import request from './index';

export function recordVisitor(data) {
  return request.post('officialVisitorLog/record', data);
}

export function getVisitorLogPage(params) {
  return request.get('officialVisitorLog/page', { params });
}

export function updateVisitorDuration(data) {
  return request.post('officialVisitorLog/updateDuration', data);
}
